'use client'

import { createContext, useContext } from 'react'
import { setRuntimePublicConfig } from '@/src/lib/runtime-public-config'
import type {
  RuntimePublicConfig,
  RuntimePublicConfigKey,
} from '@/src/lib/runtime-public-config.shared'

const RuntimeConfigContext = createContext<RuntimePublicConfig>({})

interface RuntimeConfigProviderProps {
  config: RuntimePublicConfig
  children: React.ReactNode
}

export function RuntimeConfigProvider({
  config,
  children,
}: RuntimeConfigProviderProps) {
  // Some modules read config outside React hooks; sync the shared store too.
  setRuntimePublicConfig(config)

  return (
    <RuntimeConfigContext.Provider value={config}>
      {children}
    </RuntimeConfigContext.Provider>
  )
}

export function useRuntimeConfigValue(
  key: RuntimePublicConfigKey
): string | undefined {
  const config = useContext(RuntimeConfigContext)
  return config[key] ?? process.env[key]
}
